var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorModule',{attrs:{"message":_vm.error.message,"status-code":_vm.error.statusCode}})}
var staticRenderFns = []

export { render, staticRenderFns }